/**
 * Сохранение/восстановление фильтров очереди закупки.
 *
 * Зачем: закупщик фильтрует очередь (например, поиском по бренду),
 * проваливается в позицию, оставляет комментарий, возвращается назад — и
 * фильтр сбрасывался, потому что локальный useState страницы пересоздавался.
 * Теперь весь набор фильтров переживает переход на страницу позиции и обратно.
 *
 * sessionStorage (а не localStorage): рабочий контекст нужен в пределах сессии
 * вкладки, но на следующий день очередь открывается чистой — вчерашний фильтр
 * по бренду не «залипает».
 */

import type { ClientCategory, RequestItemPriority } from '../../shared/api/types'

const STORAGE_KEY = 'procurement-queue-filters'

export interface QueueFilters {
  assignedToMe: boolean
  inQueue: boolean
  overdue: boolean
  burning: boolean
  stale: boolean
  needsInfo: boolean
  rework: boolean
  procStateFilter: 'NEW' | 'ACTIVE' | null
  category: ClientCategory | ''
  priority: RequestItemPriority | ''
  searchText: string
}

/** Прочитать сохранённые фильтры. null — если ничего не сохранено / storage недоступен. */
export function loadQueueFilters(): QueueFilters | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    return JSON.parse(raw) as QueueFilters
  } catch {
    return null
  }
}

/** Сохранить текущий набор фильтров. Ошибки storage (приватный режим) гасим. */
export function saveQueueFilters(filters: QueueFilters): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(filters))
  } catch {
    /* sessionStorage недоступен — не критично, просто не сохраняем */
  }
}
